import { render, staticRenderFns } from "./ViewAcknowledgement.vue?vue&type=template&id=4b5015aa"
import script from "./ViewAcknowledgement.vue?vue&type=script&lang=js"
export * from "./ViewAcknowledgement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports